import { useState } from "react";
import { RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isStandalone } from "@/lib/standalone";

/**
 * Manual reload control for installed PWAs. In standalone mode there is no
 * browser chrome (URL bar / pull-to-refresh), so techs have no way to force
 * a fresh load when data looks stale or after a deploy. This surfaces an
 * explicit refresh in the top bar. Hidden on desktop/browser tabs where the
 * native reload already exists.
 */
export function RefreshButton() {
    const [spinning, setSpinning] = useState(false);

    if (!isStandalone()) return null;

    const handleRefresh = () => {
        setSpinning(true);
        // Bypass any stale HTTP cache on the navigation reload.
        window.location.reload();
    };

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={handleRefresh}
            className="h-8 w-8"
            title="Refresh"
            aria-label="Refresh"
        >
            <RotateCw className={spinning ? "h-4 w-4 animate-spin" : "h-4 w-4"} />
        </Button>
    );
}
